module.exports = __webpack_public_path__ + "img/pile_of_poo.cb421585.gif";